import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
// tailwind.css se carga dinámicamente en PrivateLayoutV2 (solo rol AA-002)
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './observability/sentry';

// No-op sin REACT_APP_SENTRY_DSN. Carga el SDK de forma diferida (no entra en main.js).
initSentry();

const rootElement = document.getElementById('root');

// Si react-snap pre-renderizó HTML, hidratar en lugar de renderizar desde cero
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
